// Recovery codes, shown once (after 2-step is turned on, or after new ones are made): Copy, then "I have saved
// them". Nothing is kept in the browser.
import { CopyButton } from '@the-kit/ui'

interface RecoveryCodesBoxProps {
  codes: string[]
  onDone: () => void
  doneText?: string
}

export function RecoveryCodesBox({ codes, onDone, doneText = 'I have saved them' }: RecoveryCodesBoxProps) {
  return (
    <div className="space-y-3" data-testid="recovery-codes">
      <p className="text-xs text-default">
        Keep these somewhere safe (a password manager). If you lose your phone, each one signs you in once.
        They are not shown again.
      </p>
      <div className="card grid grid-cols-2 gap-2 font-mono text-sm text-default">
        {codes.map((code) => (
          <span key={code} className="select-all" data-testid="recovery-code">
            {code}
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <CopyButton text={codes.join('\n')} />
        <button type="button" className="btn btn-primary flex-1" onClick={onDone} data-testid="codes-saved">
          {doneText}
        </button>
      </div>
    </div>
  )
}
